import React from "react";
import "./devicebar.scss";
import DeviceBarItem from "./DeviceBarItem";
import PalamButtonBigRound from "../../../generic/palam_button_big_round";
import { Icon } from "react-icons-kit";
import { plus } from "react-icons-kit/feather/";
import { ic_filter_list as filter } from "react-icons-kit/md";

import { withTranslation } from 'react-i18next';
import moment from "moment";
import 'moment/locale/de';

moment.updateLocale("en", {
  relativeTime: {
    past: "%s ago",
    s: "%d seconds"
  }
});

moment.updateLocale("de", {
  relativeTime: {
    past: "vor %s",
    s: "%d Sekunden"
  }
});

class DeviceBar extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { tick: false, devicesFilter: "", devicesFilterActive: false };
  }

  componentDidMount() {
    let self = this;
    // This makes the "x seconds ago" label update.
    window.setInterval(() => {
      this.setState({ tick: !self.state.tick });
    }, 1000);
  }

  onFilterChange(evt) {
    console.log("onfilter change", evt.target.value);
    this.setState({ devicesFilter: evt.target.value });
  }

  onFilterClear() {
    this.setState({ devicesFilter: "" });
  }

  onFilterToggle() {
    this.setState({ devicesFilterActive: !this.state.devicesFilterActive });
  }

  render() {
    let {
      devices,
      addDevice,
      //comPaneOpen,
      //toggleDeviceComPane,
      //dataPaneOpen,
      //toggleDeviceDataPane,
      //addSensor,
      //toggleSensorDataPane,
      toggleDeviceSettings,
      startDrag,
      drag,
      setHoveredSensor,
      hoveredSensor,
      t,
      i18n
    } = this.props;

    let {language} = i18n;
    moment.locale(language);

    // Sort devices by name first. Refactor to receiveDevices!
    devices.sort((dev_a, dev_b) => {
      let name_a = "",
        name_b = "";

      try {
        if (
          dev_a &&
          dev_a.resolvedDataConfig &&
          dev_a.resolvedDataConfig.name
        ) {
          name_a = dev_a.resolvedDataConfig.name;
        } else if (dev_a && dev_a.dataConfig && dev_a.dataConfig.name.value) {
          name_a = dev_a.dataConfig.name.value;
        }
        if (
          dev_b &&
          dev_b.resolvedDataConfig &&
          dev_b.resolvedDataConfig.name
        ) {
          name_b = dev_b.resolvedDataConfig.name;
        } else if (dev_b && dev_b.dataConfig && dev_b.dataConfig.name.value) {
          name_b = dev_b.dataConfig.name.value;
        }
        name_a = name_a.toLowerCase();
        name_b = name_b.toLowerCase();
        if (name_a < name_b) {
          return -1;
        }
        if (name_a > name_b) {
          return 1;
        }
      } catch (error) {
        return 1;
      }
      return 0;
    });

    // Filter
    if (this.state.devicesFilterActive) {
      devices = devices.filter(device => {
        let rv = false;
        if (
          device.resolvedDataConfig &&
          device.resolvedDataConfig.hasOwnProperty("name")
        ) {
          let name = device.resolvedDataConfig["name"];
          rv = name.indexOf(this.state.devicesFilter) !== -1;
        } else {
          // dont filter devices that dont even have a resolveddataconfig
          rv = true;
        }

        return rv;
      });
    }

    let filterBtnCssClass = "devicebar-filterbtn";
    filterBtnCssClass += this.state.devicesFilterActive ? " active" : "";
    return (
      <div className="devicebar">
        <div className="devicebar_controls">
          <div className="devicebar-heading"><h2>{t('devices_label')}</h2></div>
          <button
            className={filterBtnCssClass}
            onClick={this.onFilterToggle.bind(this)}
          >
            <Icon size={21} icon={filter} />
          </button>
          {this.state.devicesFilterActive && (
            <div className="palam-inline-input mb-1">
              <input
                type="text"
                onChange={this.onFilterChange.bind(this)}
                value={this.state.devicesFilter}
              />
              <button
                className="palam-inline-input-clear"
                onClick={this.onFilterClear.bind(this)}
              >
                ×
              </button>
            </div>
          )}

          <PalamButtonBigRound
            label={t('add_device_label')}
            onClick={() => {
              addDevice("added");
            }}
          >
            <Icon size={24} icon={plus} />
          </PalamButtonBigRound>
        </div>
        <div className="devicebar_items" id="_devicebar_items">
          {devices.map((device, idx) => {
            let deviceName =
              device.dataConfig["name"]["value"] ||
              "Unnamed Device (" + device.uid + ")";
            let lastContact =
              device.lastContact === 0
                ? 'never'
                : moment(device.lastContact).fromNow();
            return (
              <DeviceBarItem
                name={deviceName}
                device={device}
                key={device.uid}
                deviceid={device.uid}
                comPaneOpen={device.comConfig.paneOpen}
                onDataPressed={() => {
                  toggleDeviceSettings(device.uid);
                }}
                dataPaneOpen={device.dataConfig.paneOpen}
                sensorConfig={device.sensorConfig}
                onSensorPressed={sensorKey => {
                  console.log("445", sensorKey);
                  toggleDeviceSettings(device.uid, sensorKey);
                }}
                lastContact={lastContact}
                startDrag={startDrag}
                drag={drag}
                setHoveredSensor={setHoveredSensor}
                hoveredSensor={hoveredSensor}
              />
            );
          })}
        </div>
      </div>
    );
  }
}

export default withTranslation()(DeviceBar);
